import { useMutation } from '@tanstack/react-query';
import type {
  GeneratePacketRequest,
  GeneratePacketResponse,
  PacketToJsonRequest,
  PacketToJsonResponse,
} from '@packages/types/device/common/api.common';
import { DeviceType, getProtocolForDeviceType } from '@packages/types/device/common/deviceTypes';
import { generateUnifiedPacket, parseUnifiedPacket } from './apiUnified';

function createPacketHooks(deviceType: DeviceType) {
  const protocol = getProtocolForDeviceType(deviceType);

  const useGeneratePacket = () =>
    useMutation<GeneratePacketResponse, Error, GeneratePacketRequest>({
      mutationFn: async (request: GeneratePacketRequest) => {
        const result = await generateUnifiedPacket({
          ...request,
          protocol,
          serialNumber: request.deviceInfo?.serial_number,
        });
        return { packet: result.packet };
      },
    });

  const useParsePacket = () =>
    useMutation<PacketToJsonResponse, Error, PacketToJsonRequest>({
      mutationFn: async (request: PacketToJsonRequest) => {
        const result = await parseUnifiedPacket({
          packet: request.packet,
          deviceInfo: request.deviceInfo,
          protocol,
          serialNumber: request.deviceInfo?.serial_number,
        });
        return { json: result.json };
      },
    });

  return { useGeneratePacket, useParsePacket };
}

export const litePacketHooks = createPacketHooks(DeviceType.LITE);
export const miniPacketHooks = createPacketHooks(DeviceType.MINI);
